import { createFeature, createReducer, on } from '@ngrx/store';

import { Batch } from 'app/shared/features/batch-selector/models';

import { updateBatches } from './batch.actions';

export const batchesFeatureKey = 'batch';

export interface BatchState {
    batches: Batch[];
}

export const initialState: BatchState = {
    batches: [],
};

export const reducer = createReducer(
    initialState,
    on(updateBatches, (state, { batches }) => {
        const currentJson = JSON.stringify(state.batches.sort(compareByAlphaNumericName));
        const newJson = JSON.stringify(batches.sort(compareByAlphaNumericName));
        const listChanged = currentJson !== newJson;
        return listChanged ? { ...state, batches: [...batches] } : state;
    }),
);

export const BatchReducer = createFeature({ name: batchesFeatureKey, reducer });

function compareByAlphaNumericName(a: Batch, b: Batch) {
    return a.name.localeCompare(b.name, 'en', { numeric: true });
}
